export function rowHasSpeechBuddy(row, speechbuddy) {
    const buddies = (speechbuddy || []).map((buddy) => String(buddy || '').trim()).filter((buddy) => buddy.length >= 2);
    if (!buddies.length || !row) return false;
    const raw = [row.extension, row.destination, row.transfer_from, row.transfer_to, row.ivr, row.line, row.ext_num]
        .filter((value) => value != null && value !== '')
        .join(' ');
    return buddies.some((buddy) => raw.includes(buddy));
}
